import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const UserManagementStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperContainer: {
      padding: "24px",
      borderRadius: "20px",
      border: "1px solid #F5F3EF",
      backgroundColor: "#FFF",
      boxShadow: "none",
    },
    paperHeader: {
      fontFamily: "Roobert, sans-serif",
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "24px",
      color: "#002035",
      paddingLeft: "0",
      marginBottom: "8px",
    },
    divider: {
      marginBottom: "16px",
      marginTop: "16px",
      marginLeft: "0",
      marginRight: "0",
      borderColor: "#F5F3EF",
    },
    row: {
      padding: "12px 0",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    infoMessage: {
      padding: "12px 16px",
      borderRadius: "10px",
      backgroundColor: "#FEFCF8",
      border: "none",
      marginTop: "16px",
      "& .MuiAlert-icon": {
        color: "#002035",
      },
      "& .MuiAlert-message": {
        fontFamily: "Roobert, sans-serif",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        color: "#002035",
      },
    },
    userTitle: {
      fontFamily: "Roobert, sans-serif",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "20px",
      color: "#002035",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
    paperSubHeader: {
      fontFamily: "Roobert, sans-serif",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: "#5C6469",
      paddingLeft: "0",
    },
    chip: {
      backgroundColor: "#F0FEF9",
      color: "#002035",
      fontFamily: "Roobert, sans-serif",
      fontWeight: 500,
      fontSize: "14px",
      textTransform: "capitalize",
      justifySelf: "flex-start",
      width: "min-content",
      height: "28px",
      borderRadius: "20px",
    },
    setButton: {
      height: "36px",
      whiteSpace: "nowrap",
      textTransform: "none",
      fontFamily: "Roobert, sans-serif",
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "20px",
      padding: "8px 12px",
      borderRadius: "20px",
      border: "1px solid #E5E9EB",
      backgroundColor: "#FFF",
      color: "#002035",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#F8F9F9",
        boxShadow: "none",
      },
      "&:disabled": {
        backgroundColor: "#FFF",
        color: "#9CA3A8",
        border: "1px solid #E5E9EB",
      },
    },
  }),
);
